import alt from '../alt';


class RecommendationLetterActions {
    constructor() {
        this.generateActions('getRecommendationLettersSuccess');
    }

}

export default alt.createActions(RecommendationLetterActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/RecommendationLetterActions.js
 **/